// Load icon font families only when their classes appear on the page.
(function () {
  'use strict';

  if (window.ziggaminsIconLoaderStarted) return;
  window.ziggaminsIconLoaderStarted = true;

  const families = {
    'material-icons': 'Material Icons',
    'material-icons-outlined': 'Material Icons Outlined',
    'material-icons-round': 'Material Icons Round',
    'material-icons-sharp': 'Material Icons Sharp',
    'material-icons-two-tone': 'Material Icons Two Tone',
    'material-symbols-rounded': 'Material Symbols Rounded',
    'material-symbols-sharp': 'Material Symbols Sharp'
  };

  // Material Symbols Outlined is already defined in theme.liquid.
  const requested = new Set();
  const selector = Object.keys(families)
    .map(function (name) { return '.' + name; })
    .join(',');

  function hasStylesheet(family) {
    return Array.from(document.querySelectorAll('link[href]'))
      .some(function (link) {
        if (!link.relList.contains('stylesheet')) return false;

        try {
          const url = new URL(link.href);
          if (url.hostname !== 'fonts.googleapis.com') return false;

          return url.searchParams.getAll('family').some(function (value) {
            return value.split('|').some(function (entry) {
              return entry.split(':')[0] === family;
            });
          });
        } catch (error) {
          return false;
        }
      });
  }

  function loadFamily(family) {
    if (requested.has(family)) return;
    requested.add(family);

    if (hasStylesheet(family)) return;

    const name = family.replace(/ /g, '+');
    const link = document.createElement('link');
    link.rel = 'stylesheet';

    if (family.startsWith('Material Symbols')) {
      link.href =
        'https://fonts.googleapis.com/css2?family=' + name +
        ':opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200' +
        '&display=swap';
    } else {
      link.href =
        'https://fonts.googleapis.com/icon?family=' + name +
        '&display=swap';
    }

    link.onerror = function () {
      requested.delete(family);
      link.remove();
    };

    document.head.appendChild(link);
  }

  function inspect(element) {
    element.classList.forEach(function (className) {
      if (Object.prototype.hasOwnProperty.call(families, className)) {
        loadFamily(families[className]);
      }
    });
  }

  function scan(root) {
    if (root.nodeType !== 1) return;
    inspect(root);
    root.querySelectorAll(selector).forEach(inspect);
  }

  function start() {
    scan(document.body);

    // Support icons added later by drawers, apps, or the theme editor.
    const observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          inspect(record.target);
        } else {
          record.addedNodes.forEach(scan);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();